import { useQuery } from '@tanstack/react-query'
import apiClient from '@/services/api/api'
import { JobDescription } from '@/interfaces/jobDescription'

const fetchMyJobDescription = async (): Promise<JobDescription> => {
  const response = await apiClient.get<JobDescription>('/job-descriptions/my-job-description')
  return response.data
}

export const useMyJobDescription = () => {
  return useQuery({
    queryKey: ['myJobDescription'],
    queryFn: fetchMyJobDescription,
  })
}
